import { defineChain } from 'viem'
 
export const saakuruTestnet = defineChain({
  id: 247253,
  name: 'Saakuru Testnet',
  network: 'saakuru-testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'OAS',
    symbol: 'OAS',
  },
  rpcUrls: {
    default: {
      http: ['https://rpc-testnet.saakuru.network'],
    },
    public: {
      http: ['https://rpc-testnet.saakuru.network'],
    }
  },
  blockExplorers: {
    default: { name: 'saakuru-explorer-testnet', url: 'https://explorer-testnet.saakuru.network' },
  },
  testnet: true,
});

export const saakuru = defineChain({
  id: 7225878,
  name: 'Saakuru Mainnet',
  network: 'saakuru',
  nativeCurrency: {
    decimals: 18,
    name: 'OAS',
    symbol: 'OAS',
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.saakuru.network'],
    },
    public: {
      http: ['https://rpc.saakuru.network'],
    },
  },
  blockExplorers: {
    default: { name: 'saakuru-explorer', url: 'https://explorer.saakuru.network' },
  },
});

export const bscTestnet = defineChain({
  id: 97,
  name: 'Binance Smart Chain Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'BNB',
    symbol: 'tBNB',
  },
  rpcUrls: {
    default: { http: ['https://data-seed-prebsc-1-s1.bnbchain.org:8545'] },
  },
  blockExplorers: {
    default: {
      name: 'BscScan',
      url: 'https://testnet.bscscan.com',
      apiUrl: 'https://testnet.bscscan.com/api',
    },
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 17422483,
    },
  },
  testnet: true,
})

export const bsc = defineChain({
  id: 56,
  name: 'BNB Smart Chain',
  nativeCurrency: {
    decimals: 18,
    name: 'BNB',
    symbol: 'BNB',
  },
  rpcUrls: {
    default: { http: ['https://bsc-dataseed.bnbchain.org', 'https://bsc-dataseed-public.bnbchain.org'] },
  },
  blockExplorers: {
    default: {
      name: 'BscScan',
      url: 'https://bscscan.com',
      apiUrl: 'https://api.bscscan.com/api',
    },
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 15921452,
    },
  },
})